import * as React from 'react';
import { StoreProvider } from './src/components/StoreContext';
import '@fontsource/lato'; // Defaults to weight 400 with all styles included.
import '@fontsource/open-sans'; // Defaults to weight 400 with all styles included.

export const wrapRootElement = ({ element }) => <StoreProvider>{element}</StoreProvider>;
